const BASE = `${process.env.REACT_APP_API_HOST}/api/v2`;

const headers = (idToken) => ({
  'Content-Type': 'application/json',
  'br-token': idToken,
});

const handle = async (res) => {
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      if (body && body.msg) msg = body.msg;
    } catch (e) {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
};

export const listMine = (idToken) =>
  fetch(`${BASE}/sample-chapters/mine`, {headers: headers(idToken)}).then(handle);

export const getSample = (idToken, id) =>
  fetch(`${BASE}/sample-chapters/${id}`, {headers: headers(idToken)}).then(handle);

export const createSample = (idToken, data) =>
  fetch(`${BASE}/sample-chapters`, {
    method: 'POST',
    headers: headers(idToken),
    body: JSON.stringify(data),
  }).then(handle);

export const updateSample = (idToken, id, data) =>
  fetch(`${BASE}/sample-chapters/${id}`, {
    method: 'PUT',
    headers: headers(idToken),
    body: JSON.stringify(data),
  }).then(handle);

export const deleteSample = (idToken, id) =>
  fetch(`${BASE}/sample-chapters/${id}`, {
    method: 'DELETE',
    headers: headers(idToken),
  }).then(handle);

export const rateSample = (idToken, id, data) =>
  fetch(`${BASE}/sample-chapters/${id}/rate`, {
    method: 'POST',
    headers: headers(idToken),
    body: JSON.stringify(data),
  }).then(handle);

export const revokeContact = (idToken, id) =>
  fetch(`${BASE}/sample-chapters/${id}/revoke-contact`, {
    method: 'POST',
    headers: headers(idToken),
  }).then(handle);

export const generateAudio = (idToken, id, data) =>
  fetch(`${BASE}/sample-chapters/${id}/generate-audio`, {
    method: 'POST',
    headers: headers(idToken),
    body: JSON.stringify(data || {}),
  }).then(handle);

export const getStats = (idToken, id) =>
  fetch(`${BASE}/sample-chapters/${id}/stats`, {headers: headers(idToken)}).then(handle);

export const listVoices = (idToken) =>
  fetch(`${BASE}/sample-chapters/voices`, {headers: headers(idToken)}).then(handle);

export const listSourceBooks = (idToken) =>
  fetch(`${BASE}/sample-chapters/source-books`, {headers: headers(idToken)}).then(handle);

export const getSourceChapter = (idToken, bookId, chapterId) =>
  fetch(
    `${BASE}/sample-chapters/source-chapter?bookId=${encodeURIComponent(bookId)}&chapterId=${encodeURIComponent(chapterId)}`,
    {headers: headers(idToken)}
  ).then(handle);

export const discoverSamples = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== '') qs.set(k, String(v));
  });
  const url = `${BASE}/ereader/discover/samples${
    qs.toString() ? `?${qs.toString()}` : ''
  }`;
  return fetch(url).then(handle);
};
